import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { CacheService } from './shared/services/cache.service';
import { DialogService } from './shared/services/dialog.service';
import { MasterdataService } from './shared/services/masterdata.service';
import { Store } from '@ngrx/store';
import { FaqActions, HomeActions } from './store';
import { CacheCleanupService } from './shared/services/cache-cleanup.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    showHeader = false;
    showFooter = false;
    maintenance: boolean = false;
    activeComponent;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private masterdataService: MasterdataService,
        private cacheService: CacheService,
        private dialogService: DialogService,
        private store: Store,
        private cacheCleanupService: CacheCleanupService
    ) {
        store.dispatch(HomeActions.loadNews({}));
        this.cacheService.initCache();
        this.cacheCleanupService.checkCacheVersion();
    }

    ngOnInit() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.showHeader = (this.activatedRoute.firstChild.snapshot.data as any).showHeader !== false;
                this.showFooter = (this.activatedRoute.firstChild.snapshot.data as any).showFooter !== false;
                window.scrollTo(0, 0);
            }
        });

        this.dialogService.activeComponent().subscribe((activeComponent) => {
            if (!activeComponent) {
                this.closeDialog();
            }
            this.activeComponent = activeComponent;
        });

        this.dialogService.getMaintenanceMode().subscribe((enabled) => {
            this.maintenance = enabled;
        });

        this.store.dispatch(FaqActions.loadFaqStores());
    }

    closeDialog() {
        this.maintenance = false;
    }
}
